import dayjs from 'dayjs';

interface MileageRate {
    id: number;
    rate: string;
    effective_date: string;
}

// Select the mileage rate for the year of the selected period.
// If no rate is found for the selected period, select the closest past rate.
export const selectLatestMileageRate = (data: MileageRate[], selectedPeriod: dayjs.Dayjs): MileageRate | undefined => {
    if (!data?.length) {
        return undefined;
    }

    const sortedRates = [...data].sort((a, b) => (dayjs(b.effective_date).isAfter(dayjs(a.effective_date)) ? 1 : -1));

    // Find the rate in sortedRates that is on or before the selected period
    // Since sortedRates is sorted in descending order (newest first), we find the first rate
    // where the effective_date is on or before the selected period

    // Normalize selectedPeriod to the first day of the month for accurate comparison
    const normalizedSelectedPeriod = selectedPeriod.startOf('month');

    return (
        sortedRates.find((rate) => {
            const effectiveDate = dayjs(rate.effective_date).startOf('month');
            return effectiveDate.isSameOrBefore(normalizedSelectedPeriod);
        }) || sortedRates[sortedRates.length - 1]
    );
};
